import { __rest } from "tslib";
import React from 'react';
import { navigate } from 'gatsby';
import { apiHolder, apis, util, } from 'api';
import { transContactModel2ContactItem } from '@web-common/components/util/contact';
import isEqual from 'lodash/isEqual';
import lodashGet from 'lodash/get';
import lodashZip from 'lodash/zip';
import { getIn18Text } from 'api';
export const contactApi = apiHolder.api.requireLogicalApi(apis.contactApiImpl);
export const systemApi = apiHolder.api.getSystemApi();
const accountApi = apiHolder.api.requireLogicalApi(apis.accountApiImpl);
const mailPlusCustomerApi = apiHolder.api.requireLogicalApi(apis.mailPlusCustomerApiImpl);
export const data2Tree = (data) => {
    const treeNode = {
        key: data.org.id,
        value: data.org,
        title: data.org.orgName,
        isLeaf: false,
    };
    if (data.children && data.children.length > 0) {
        treeNode.children = data.children.map(data2Tree);
    }
    return treeNode;
};
export const data2Leaf = (data, type) => {
    let leafNode;
    const infos = data.contactInfo.filter(info => info.contactItemType === type && info.contactItemVal);
    if (infos.length === 1) {
        const key = data.contact.id;
        leafNode = {
            key,
            title: React.createElement(React.Fragment, null, data.contact.contactName),
            isLeaf: true,
            value: data,
        };
    }
    else {
        leafNode = {
            key: data.contact.id,
            title: React.createElement(React.Fragment, null, data.contact.contactName),
            isLeaf: false,
            children: infos.map(info => ({
                key: `${data.contact.id}|${info.contactItemVal}`,
                title: React.createElement(React.Fragment, null, info.contactItemVal),
                isLeaf: true,
                value: Object.assign(Object.assign({}, data), { contactInfo: [info] }),
            })),
        };
    }
    return leafNode;
};
export var StaticNodeKey;
(function (StaticNodeKey) {
    StaticNodeKey["PERSON"] = "person";
    StaticNodeKey["PERSON_ALL"] = "personal_all";
    StaticNodeKey["PERSON_NO_GROUP"] = "personal_no_group";
    StaticNodeKey["CORP"] = "corp";
    StaticNodeKey["GROUP"] = "group";
    StaticNodeKey["PERSON_MARK_LIST"] = "personal_mark_list";
})(StaticNodeKey || (StaticNodeKey = {}));
export var StaticRootNodeKey;
(function (StaticRootNodeKey) {
    StaticRootNodeKey["PERSON"] = "personalRoot";
    StaticRootNodeKey["ENTERPRISE"] = "enterpriseRoot";
    StaticRootNodeKey["TEAM"] = "teamRoot";
    StaticRootNodeKey["RECENT"] = "recentRoot";
    StaticRootNodeKey["CUSTOMER"] = "customerRoot";
})(StaticRootNodeKey || (StaticRootNodeKey = {}));
export var SearchGroupKey;
(function (SearchGroupKey) {
    SearchGroupKey[SearchGroupKey["ALL"] = 0] = "ALL";
    SearchGroupKey[SearchGroupKey["CORP"] = 1] = "CORP";
    SearchGroupKey[SearchGroupKey["PERSON"] = 2] = "PERSON";
    SearchGroupKey[SearchGroupKey["TEAM"] = 3] = "TEAM";
})(SearchGroupKey || (SearchGroupKey = {}));
export const updatePersonTreeData = (list, children) => list.map(node => {
    if (node.key === StaticNodeKey.PERSON_ALL) {
        return Object.assign(Object.assign({}, node), { title: `${getIn18Text('SUOYOULIANXIREN11')}（${children.length}）`, children: (node.children || []).concat(children) });
    }
    if (node.children) {
        return Object.assign(Object.assign({}, node), { children: updatePersonTreeData(node.children, children) });
    }
    return node;
});
export const updateOrgTreeData = (list, key, child, noChildToLeaf) => {
    return list.map(node => {
        if (node.key === key) {
            const children = (node.children || []).concat(child);
            if (children.length === 0 && noChildToLeaf) {
                return Object.assign(Object.assign({}, node), { isLeaf: true, children });
            }
            return Object.assign(Object.assign({}, node), { children });
        }
        if (node.children) {
            return Object.assign(Object.assign({}, node), { children: updateOrgTreeData(node.children, key, child, noChildToLeaf) });
        }
        return node;
    });
};
export const updateOrgTreeDataV2 = (params) => {
    const { data, key, item = {}, child = [], noChildToLeaf } = params;
    return data.map(node => {
        if (node.key === key) {
            const children = (node.children || []).concat(child);
            if (children.length === 0 && noChildToLeaf) {
                return Object.assign(Object.assign({}, node), { isLeaf: true, children });
            }
            return Object.assign(Object.assign(Object.assign({}, node), item), { children });
        }
        if (node.children) {
            return Object.assign(Object.assign({}, node), { children: updateOrgTreeData(node.children, key, child, noChildToLeaf) });
        }
        return node;
    });
};
export const EntityContact2ContactModel = (contact) => ({
    contact,
    contactInfo: [],
});
export const getCharAvatar = (name = '') => name.charAt(0).toLocaleUpperCase();
export const contact4ui = (list, pointLabel) => {
    const labels = new Set();
    if (!list) {
        return [];
    }
    return list.map(item => {
        const r = Object.assign({}, item);
        r.contact.defaultEmail = item.contact.accountName;
        r.contact.charAvatar = getCharAvatar(item.contact.contactName);
        if (pointLabel) {
            if (!labels.has(r.contact.contactLabel)) {
                r.contact.labelPoint = true;
                labels.add(r.contact.contactLabel);
            }
        }
        return r;
    });
};
export const teamAddTopUser = async (list) => {
    const idList = list.map(item => item.id);
    const params = {
        idList,
        needGroup: true,
        needContactData: true,
        needContactModelData: false,
    };
    const res = (await contactApi.doGetOrgContactListByTeamId(params));
    res.forEach((contactArr, index) => {
        const ownerArr = [];
        const managerArr = [];
        const normalArr = [];
        contactArr.forEach(contact => {
            switch (contact.type) {
                case 'owner':
                    ownerArr.push(contact);
                    break;
                case 'manager':
                    managerArr.push(contact);
                    break;
                case 'normal':
                    normalArr.push(contact);
                    break;
                default:
                    break;
            }
        });
        list[index].topUsers = [...ownerArr, ...managerArr, ...normalArr].splice(0, 3);
    });
};
export const getContact = async (orgId) => {
    const list = await contactApi.doGetContactByOrgId({ orgId });
    return contact4ui(list);
};
export const getAllPersonContact = async (node, level = 1) => {
    var _a;
    const { key, children = [] } = node;
    let ret = (await getContact(String(key))) || [];
    if (level <= 0) {
        return ret;
    }
    for (const child of children) {
        if (!child.isLeaf && ((_a = child.children) === null || _a === void 0 ? void 0 : _a.length)) {
            const list = await getAllPersonContact(child, level - 1);
            ret = ret.concat(list);
        }
        else if (!child.isLeaf) {
            const list = (await getContact(String(child.key))) || [];
            ret = ret.concat(list);
        }
    }
    return ret;
};
export const getPersonContact = async (options = {}) => {
    const data = await contactApi.doGetPersonalContact(options);
    return contact4ui(data, !0);
};
export const getOrgs = async (options = {}) => {
    const orgData = await contactApi.doGetContactOrg(options);
    return orgData;
};
export const getOrgNode = async (key) => {
    const orgData = await contactApi.doGet(key);
    return data2Tree(orgData);
};
export const escapeRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
export const getContactById = async (id) => {
    const data = await contactApi.doGetContactById(id);
    const list = contact4ui(data);
    return list;
};
export const getOrgById = async (id, type) => {
    const req = type === 'origin' ? { originIdList: id } : { idList: id };
    const data = await contactApi.doGetOrgList(req);
    return data;
};
export const getOrgByOriginId = async (id) => getOrgById(id, 'origin');
export const getTeamById = async (list) => {
    const data = await contactApi.doGetTeamList(list);
    await teamAddTopUser(data);
    return data;
};
export const searchContact = async (option) => {
    const { query, isIM = false, filter, showDisable, noRelateEnterprise } = option;
    if (!query) {
        return null;
    }
    const data = await contactApi.doSearchAllContact({
        query,
        showDisable,
        isIM,
        filter,
        noRelateEnterprise,
    });
    console.log('2222---doSearchAllContact', data);
    await teamAddTopUser(data.teamList);
    return {
        [SearchGroupKey.CORP]: data.orgList,
        [SearchGroupKey.PERSON]: contact4ui(data.contactList),
        [SearchGroupKey.TEAM]: data.teamList,
    };
};
export const getSearchContact = async (searchValue, isIM, noLock) => {
    if (!searchValue) {
        return null;
    }
    const data = await contactApi.doSearchContact(searchValue, isIM, noLock);
    const list = contact4ui(data);
    return {
        [SearchGroupKey.ALL]: list,
        [SearchGroupKey.CORP]: list.filter(e => e && e.contact && e.contact.type === 'enterprise'),
        [SearchGroupKey.PERSON]: list.filter(e => e && e.contact && e.contact.type === 'personal'),
    };
};
export const getSearchAllContactInWriteMail = (option, onResult) => {
    var _a;
    const { query, showDisable, isIM, curAccountId, flattenMuliptleEmails } = option;
    const _account = curAccountId || ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id);
    const resolve = onResult || (() => { });
    contactApi.doSearchAllContactNew({
        query,
        showDisable,
        isIM,
        useFrequentOrder: true,
        useEdmData: process.env.BUILD_ISEDM,
        _account,
        flattenMuliptleEmails,
        maxItem: 100,
    }, async ({ main, edm }) => {
        const personalorgIdsWithAccount = {};
        if (_account && Reflect.has(main, _account)) {
            personalorgIdsWithAccount[_account] = lodashGet(main, `['${_account}'].personalOrgList`, []).map(item => {
                return item.id;
            });
        }
        else {
            Object.keys(main).forEach(subEmail => {
                personalorgIdsWithAccount[subEmail] = lodashGet(main, `['${subEmail}'].personalOrgList`, []).map(item => {
                    return item.id;
                });
            });
        }
        try {
            const accountList = Object.keys(personalorgIdsWithAccount);
            const promiseRequestList = accountList.map(_account => {
                return contactApi.queryPersonalMemberCount(personalorgIdsWithAccount[_account], _account);
            });
            const res = await Promise.all(promiseRequestList);
            const countMap = new Map(lodashZip(accountList, res));
            for (let subEmail in main) {
                if (!countMap.has(subEmail) || !main[subEmail].personalOrgList) {
                    continue;
                }
                main[subEmail].personalOrgList = main[subEmail].personalOrgList
                    .filter(orgItem => {
                    const { id } = orgItem;
                    return lodashGet(countMap.get(subEmail), `${id}`, 0);
                })
                    .map(orgItem => {
                    const { id } = orgItem;
                    orgItem.orgName = `${orgItem.orgName}(联系组)`;
                    orgItem.memberNum = lodashGet(countMap.get(subEmail), `${id}`, 0);
                    return orgItem;
                });
            }
        }
        catch (ex) { }
        if (_account) {
            const recent = await getSearchRecentContactList(query, _account);
            resolve({
                data: main[_account] ? [main[_account]] : [],
                edm,
                recent,
            });
        }
        else {
            resolve({
                data: Object.values(main) || [],
                edm,
            });
        }
    });
};
const getContactModelByRecent = async (value, _account) => {
    const emails = value.map(item => item.email);
    const contactModelMap = await contactApi.doGetContactByEmail({ emails, _account });
    const res = [];
    value.forEach(item => {
        const { nickname, name, email } = item;
        const contactName = nickname || name || email;
        const modelList = contactModelMap[item.email];
        if (modelList === null || modelList === void 0 ? void 0 : modelList.length) {
            let model;
            modelList.forEach(itemModel => {
                const cur = transContactModel2ContactItem(itemModel);
                if (model) {
                    model = getValidEmail(model, cur);
                }
                else {
                    model = cur;
                }
            });
            if (model) {
                res.push(model);
            }
            else {
                res.push({
                    name: contactName,
                    email,
                    type: 'external',
                });
            }
        }
        else {
            res.push({
                name: contactName,
                email,
                type: 'external',
            });
        }
    });
    return res;
};
const getSearchRecentContactList = async (query, _account) => {
    const res = await contactApi.getRecentContactList({
        page: 1,
        pageSize: 30,
        conditionType: 1,
        contactType: 1,
        _account,
    });
    const filters = [];
    if (res === null || res === void 0 ? void 0 : res.length) {
        res.forEach(item => {
            var _a;
            if (item.email.includes(query) || ((_a = item.nickname) === null || _a === void 0 ? void 0 : _a.includes(query))) {
                filters.push(item);
            }
        });
    }
    const list = await getContactModelByRecent(filters, _account);
    return list;
};
export const syncAll = async (force) => {
    const orgData = await contactApi.syncAll(force);
    return [orgData];
};
export const getDisplayEmailInfo = (list) => {
    return list.filter(item => item.contactItemType === 'EMAIL' && !(item.type === 'enterprise' && !item.isDefault));
};
export const transAvatarSize = (avatar, type) => {
    const sizeMap = {
        mini: '32x32',
        small: '80x80',
        middle: '180x180',
        big: '480x480',
    };
    let curAvatarSize;
    Object.values(sizeMap).forEach(item => {
        if (avatar.includes(item)) {
            curAvatarSize = item;
        }
    });
    if (!curAvatarSize) {
        throw new Error(getIn18Text('BIXUCHUANRU3'));
    }
    return avatar.replace(curAvatarSize, sizeMap[type]);
};
export const getValidEmail = (pre, cur, isMainAccount = true) => {
    const compareArr = ['type', 'customerRole', 'createTime', 'id'];
    const compareMap = {
        type: {
            enterprise: 5,
            customer: 4,
            clue: 3,
            personal: 2,
            external: 1,
            team: -1,
            recent: -1,
        },
        customerRole: {
            manager: 4,
            colleague: 3,
            openSea: 2,
            other: 1,
            undefined: 0,
        },
        status: {
            '1': 1,
            '2': 1,
            '3': 1,
            '4': 0,
            '5': 1,
        },
    };
    let result;
    compareArr.forEach(prop => {
        if (!result && pre[prop] !== cur[prop]) {
            let value = pre[prop];
            let value2 = cur[prop];
            const obj = compareMap[prop];
            if (obj) {
                value = obj[value + ''];
                value2 = obj[value2 + ''];
            }
            if (value && value2) {
                result = value.toString().localeCompare(value2.toString(), 'zh') >= 0 ? pre : cur;
            }
        }
    });
    return result || pre;
};
export const getDisplayContactItem = (list, type, _account) => {
    let selectContactItem;
    let filterList = type ? list.filter(item => type === item.type) : list;
    if (_account) {
        filterList = filterList.filter(item => {
            return accountApi.getIsSameSubAccountSync(_account, item._account || '') || item.type === 'customer' || item.type === 'clue';
        });
    }
    filterList.forEach(item => {
        if (selectContactItem) {
            selectContactItem = getValidEmail(selectContactItem, item);
        }
        else {
            selectContactItem = item;
        }
    });
    return selectContactItem;
};
export const customerTypeToText = (item) => {
    let res = '';
    if (item.type === 'customer') {
        res += item.customerRole === 'manager' ? getIn18Text('mine') : getIn18Text('colleague');
        res += getIn18Text('customer');
    }
    else if (item.type === 'clue') {
        res += item.customerRole === 'manager' ? getIn18Text('mine') : getIn18Text('colleague');
        res += getIn18Text('clue');
    }
    return res;
};
export const emailRoleToText = (emailRole) => {
    const obj = {
        myClue: getIn18Text('WODEXIANSUO'),
        myCustomer: getIn18Text('WODEKEHU'),
        colleagueClue: getIn18Text('TONGSHIXIANSUO'),
        colleagueClueNoAuth: getIn18Text('TONGSHIXIANSUO'),
        colleagueCustomer: getIn18Text('TONGSHIKEHU'),
        colleagueCustomerNoAuth: getIn18Text('TONGSHIKEHU'),
        openSeaClue: getIn18Text('GONGHAIXIANSUO'),
        openSeaCustomer: getIn18Text('GONGHAIKEHU'),
    };
    return emailRole ? obj[emailRole] || '' : '';
};
export const buildContactModel = (item, reduxParams) => {
    const type = ['enterprise', 'personal', 'customer', 'clue', 'external'].includes(item.type) ? item.type : 'external';
    const name = item.name || item.email;
    const model = {
        contact: {
            id: item.id || '',
            contactName: name,
            accountName: item.email,
            visibleCode: 0,
            contactPYName: util.toPinyin(name),
            contactLabel: util.getContactLabel(name),
            contactPYLabelName: util.getContactPYLabel(name),
            accountType: 2,
            accountId: '',
            displayEmail: item.email,
            enableIM: false,
            type,
            color: util.getColor(item.email),
            _lastUpdateTime: Date.now(),
        },
        contactInfo: [
            {
                id: item.id || '',
                contactItemType: 'EMAIL',
                contactId: '',
                contactItemVal: item.email,
                type,
                isDefault: 1,
                contactItemRefer: '',
                _lastUpdateTime: Date.now(),
            },
        ],
        _account: item._account,
    };
    return Object.assign(model, reduxParams || {});
};
export const transMailContactModel2ContactItem = (item) => {
    var _a, _b;
    const model = item === null || item === void 0 ? void 0 : item.contact;
    const { id, type, avatar, contactName, position, accountType } = (model === null || model === void 0 ? void 0 : model.contact) || {};
    const email = contactApi.doGetModelDisplayEmail(model);
    return {
        id,
        type,
        avatar,
        name: contactName,
        email,
        position,
        accountType,
        customerRole: (_a = model === null || model === void 0 ? void 0 : model.customerOrgModel) === null || _a === void 0 ? void 0 : _a.role,
        createTime: (_b = model === null || model === void 0 ? void 0 : model.customerOrgModel) === null || _b === void 0 ? void 0 : _b.createTime,
        mailMemberType: item.mailMemberType,
    };
};
export const transServerRecent2ContactItem = (item) => {
    const { accountId, nickname, email, name, iconUrl } = item;
    return {
        id: accountId,
        name: nickname || name || email,
        email,
        avatar: iconUrl,
        type: 'recent',
    };
};
export const buildContactItem = (item) => {
    const { email, name, type } = item;
    return {
        email,
        name: name || email,
        mailMemberType: type,
        type: 'external',
    };
};
export const transContactItem2MailContactModel = (item) => {
    const model = buildContactModel(item);
    return {
        contact: model,
        contactItem: model.contactInfo[0],
        mailMemberType: item.mailMemberType || 'to',
        inContactBook: item.type !== 'external',
    };
};
export const transContactModel2MailContactModel = (item, receiverType) => {
    const email = contactApi.doGetModelDisplayEmail(item);
    const hitQueryEmailFirst = lodashGet(item, 'contact.hitQueryEmail.length', 0) && item.contact.type === 'personal';
    const cHitqueryEmailItem = hitQueryEmailFirst
        ? item.contactInfo.find(info => {
            if (info.contactItemType !== 'EMAIL') {
                return false;
            }
            return info.contactItemVal.toLocaleLowerCase() === email;
        })
        : null;
    const cItem = cHitqueryEmailItem ||
        item.contactInfo.find(info => {
            return info.contactItemType === 'EMAIL' && info.isDefault === 1;
        });
    const contactInfo = {
        id: '',
        contactId: item.contact.id,
        contactItemType: 'EMAIL',
        contactItemVal: contactApi.doGetModelDisplayEmail(item),
        contactItemRefer: '',
        type: item.contact.type,
        isDefault: 1,
        _lastUpdateTime: Date.now(),
    };
    return {
        contact: item,
        mailMemberType: receiverType,
        contactItem: cItem || contactInfo,
        inContactBook: item.contact.type !== 'external',
    };
};
export const transServerCustomerContact2CustomerContactModel = (item, type) => {
    const { contact_id: id, contact_name, contact_icon: avatar, email: account, main_contact: mainContact } = item, extra = __rest(item, ["contact_id", "contact_name", "contact_icon", "email", "main_contact"]);
    const name = contact_name || account;
    const contactPYName = util.toPinyin(name);
    const contactLabel = util.getContactLabel(contactPYName);
    const _lastUpdateTime = Date.now();
    return Object.assign(Object.assign({}, extra), { id, originId: id, name,
        contactPYName, contactPYLabelName: '', contactLabel,
        avatar,
        account,
        _lastUpdateTime,
        mainContact, customerType: type, _company: '' });
};
export const transServerCustomerContact2ContactModel = (params) => {
    const { item, type, role, id } = params;
    const currentModel = transServerCustomerContact2CustomerContactModel(item, type);
    const contact = {
        id: currentModel.id,
        contactName: currentModel.name,
        contactLabel: currentModel.contactLabel,
        contactPYName: currentModel.contactPYName,
        contactPYLabelName: currentModel.contactPYLabelName,
        accountName: currentModel.account,
        displayEmail: currentModel.account,
        visibleCode: 0,
        enableIM: false,
        accountType: 2,
        type,
        accountId: currentModel.id,
        _lastUpdateTime: currentModel._lastUpdateTime,
    };
    const contactInfo = [
        {
            id: '',
            contactId: currentModel.id,
            contactItemType: 'EMAIL',
            contactItemVal: currentModel.account,
            isDefault: 1,
            type,
            contactItemRefer: '',
            _lastUpdateTime: currentModel._lastUpdateTime,
        },
    ];
    return {
        contact,
        contactInfo: contactInfo,
        customerOrgModel: {
            role: role,
            companyId: id,
            currentModel,
        },
        isFull: true,
    };
};
export const transServerCustomerContact2SimpleContactModel = (contact) => {
    return {
        id: contact.contact_id,
        email: contact.email,
        name: contact.contact_name || contact.email,
        isMain: contact.main_contact,
    };
};
export const transServerCustomer2CustomerModel = (item) => {
    const { company_name: orgName, company_number: number, company_domain: domain, company_logo: logo, short_name: shortName, source_name: sourceName, source, company_level: cLevel, company_level_name: cLevelName, contact_list, manager_list, label_list, label_names, star_level: starLevel, company_id: id, originCompanyId, area, create_time, main_contact } = item, extra = __rest(item, ["company_name", "company_number", "company_domain", "company_logo", "short_name", "source_name", "source", "company_level", "company_level_name", "contact_list", "manager_list", "label_list", "label_names", "star_level", "company_id", "originCompanyId", "area", "create_time", "main_contact"]);
    let contactList = [];
    contact_list === null || contact_list === void 0 ? void 0 : contact_list.forEach(contact => {
        if (contact) {
            contactList.push({
                id: contact.contact_id,
                email: contact.email,
                name: contact.contact_name,
                isMain: contact.main_contact,
            });
        }
    });
    if (contactList.length === 0 && main_contact) {
        contactList = [
            {
                id: main_contact.contact_id,
                email: main_contact.email,
                name: main_contact.contact_name,
                isMain: main_contact.main_contact,
            },
        ];
    }
    const managerNames = [];
    const managerList = manager_list === null || manager_list === void 0 ? void 0 : manager_list.map(manager => {
        managerNames.push(manager.name);
        return {
            managerId: manager.id,
            managerAccount: manager.email,
            managerName: manager.name,
            iconUrl: manager.iconUrl,
            lastMailTime: manager.lastMailTime,
            managerOriginName: manager.manager_name,
        };
    });
    const labelList = label_list === null || label_list === void 0 ? void 0 : label_list.map(label => {
        const { label_id: id, label_name: name = '', label_color: color = '', label_color_origin, label_create_time: createTime = 0, label_type: type = 0, label_company_count: companyCount, label_contact_count: contactCount, label_remark: remark, create_account: createAccount, create_account_id: createAccountId, } = label;
        return {
            id: id,
            name,
            type,
            color: label_color_origin || color,
            createTime,
            remark,
            companyCount,
            contactCount,
            createAccountId,
            createAccount,
        };
    });
    const orgPYName = util.toPinyin(orgName);
    return Object.assign(Object.assign({}, extra), { createTime: create_time, shortName, area: Array.isArray(area)
            ? area.reduce((str, cur) => {
                if (cur) {
                    str = (str ? str + '-' : '') + cur;
                }
                return str;
            }, '')
            : area, domain,
        logo, website: item.website, cLevel: cLevel, cLevelName,
        number, starLevel: starLevel, companyName: orgName, id, originCompanyId: originCompanyId || id, originId: id, orgName,
        orgPYName, parent: 'customer', type: 2003, orgRank: Number(create_time), visibleCode: 0, contactList,
        managerList,
        labelList,
        managerNames, labelNames: label_names, _lastUpdateTime: Date.now(), sourceName: sourceName, sourceId: source + '', main_contact,
        contact_list });
};
export const transManagerList2ManagerModel = (manager_list = []) => {
    const managerList = manager_list === null || manager_list === void 0 ? void 0 : manager_list.map(manager => {
        return {
            managerId: manager.id,
            managerAccount: manager.email,
            managerName: manager.name,
            iconUrl: manager.iconUrl,
            lastMailTime: manager.lastMailTime,
            managerOriginName: manager.manager_name,
        };
    });
    return managerList;
};
export const transICustomerModel2DetailDataType = (customer, emailRole) => {
    if (!customer)
        return null;
    const { address, attachment, area, city, auto_created, createTime, companyName, orgName, company_name_id, continent, country, country_id, create_by, create_by_id, create_source, create_type, create_type_relate_key, customized_field_value, edm_labels, edm_statistic, fax, labelList, labelNames, latest_contact, main_contact, managerList, multi_main_industry, next_follow_at, province, recent_follow_at, recent_follow_by, recent_follow_by_id, recommend_company_data_id, remark, require_product, sales_type, scale, social_media, sourceId, starLevel, telephone, update_by, update_by_id, update_time, website, cold_rc_email_cnt, domain, id, cLevel, cLevelName, logo, number, contact_list, customer_follow_status, customer_stage, destination_port, exchange_cnt, favorite, hasBindOpportunity, monitorIdFromBigData, open_sea_grouping_id, purchase_amount, zone, originCompanyId, return_managers, return_reason, return_remark, return_source, return_time, leads_score, product_require_level, relation_company_deleted, relation_company_id, relation_company_name, status, unread, relation_leads_id, relation_leads_name, shortName, sourceName, main_industry, invalid_status } = customer, extra = __rest(customer, ["address", "attachment", "area", "city", "auto_created", "createTime", "companyName", "orgName", "company_name_id", "continent", "country", "country_id", "create_by", "create_by_id", "create_source", "create_type", "create_type_relate_key", "customized_field_value", "edm_labels", "edm_statistic", "fax", "labelList", "labelNames", "latest_contact", "main_contact", "managerList", "multi_main_industry", "next_follow_at", "province", "recent_follow_at", "recent_follow_by", "recent_follow_by_id", "recommend_company_data_id", "remark", "require_product", "sales_type", "scale", "social_media", "sourceId", "starLevel", "telephone", "update_by", "update_by_id", "update_time", "website", "cold_rc_email_cnt", "domain", "id", "cLevel", "cLevelName", "logo", "number", "contact_list", "customer_follow_status", "customer_stage", "destination_port", "exchange_cnt", "favorite", "hasBindOpportunity", "monitorIdFromBigData", "open_sea_grouping_id", "purchase_amount", "zone", "originCompanyId", "return_managers", "return_reason", "return_remark", "return_source", "return_time", "leads_score", "product_require_level", "relation_company_deleted", "relation_company_id", "relation_company_name", "status", "unread", "relation_leads_id", "relation_leads_name", "shortName", "sourceName", "main_industry", "invalid_status"]);
    const label_list = labelList === null || labelList === void 0 ? void 0 : labelList.map(label => ({
        label_id: label.id,
        label_name: label.name,
        label_color: label.color,
        label_color_origin: label.color,
        label_create_time: label.createTime,
        label_type: label.type,
        label_company_count: label.companyCount,
        label_contact_count: label.contactCount,
        label_remark: label.remark,
        create_account: label.createAccount,
        create_account_id: label.createAccountId,
    }));
    const manager_list = managerList === null || managerList === void 0 ? void 0 : managerList.map(manager => ({
        id: manager.managerId,
        email: manager.managerAccount,
        name: manager.managerName,
        iconUrl: manager.iconUrl,
        lastMailTime: manager.lastMailTime,
        manager_name: manager.managerOriginName,
    }));
    const commonProperties = Object.assign({ address,
        attachment, area: area ? area.split('-') : [], city,
        auto_created, company_name: companyName || orgName, company_name_id,
        continent,
        country,
        country_id,
        create_by,
        create_by_id, create_source: create_source, create_time: createTime, create_type,
        create_type_relate_key, customized_field_value: customized_field_value, edm_labels,
        edm_statistic,
        fax,
        label_list, label_names: labelNames, latest_contact, main_industry: `${main_industry}`, main_contact: main_contact, manager_list,
        multi_main_industry,
        next_follow_at,
        province,
        recent_follow_at,
        recent_follow_by,
        recent_follow_by_id,
        recommend_company_data_id,
        remark,
        require_product,
        sales_type,
        scale, social_media: social_media, source: sourceId ? +sourceId : 0, star_level: starLevel ? +starLevel : 0, telephone,
        update_by,
        update_by_id,
        update_time,
        website,
        relation_leads_id,
        relation_leads_name, short_name: shortName, source_name: sourceName, zone,
        relation_company_id,
        relation_company_name, company_logo: logo, invalid_status: invalid_status ? +invalid_status : 0, cold_rc_email_cnt, company_domain: domain, id, company_id: id, company_level: cLevel ? +cLevel : 0, company_level_name: cLevelName, company_number: number, contact_list,
        customer_follow_status,
        customer_stage,
        destination_port,
        exchange_cnt,
        favorite,
        hasBindOpportunity,
        monitorIdFromBigData,
        open_sea_grouping_id,
        purchase_amount, return_managers: return_managers, return_reason,
        return_remark,
        return_source,
        return_time, leads_id: +id, leads_name: companyName, leads_number: number, leads_score,
        product_require_level,
        relation_company_deleted, status: status ? +status : 0, unread }, extra);
    const CustomerOpenSeaList2VO_OBJ = {
        company_id: originCompanyId,
    };
    const LeadsOpenSeaVO_OBJ = {
        leads_id: +originCompanyId,
    };
    if (emailRole === 'myCustomer' || emailRole === 'colleagueCustomer' || emailRole === 'colleagueCustomerNoAuth') {
        return Object.assign({}, commonProperties);
    }
    else if (emailRole === 'openSeaCustomer') {
        return Object.assign(Object.assign({}, commonProperties), CustomerOpenSeaList2VO_OBJ);
    }
    else if (emailRole === 'myClue' || emailRole === 'colleagueClue' || emailRole === 'colleagueClueNoAuth') {
        return Object.assign({}, commonProperties);
    }
    else if (emailRole === 'openSeaClue') {
        return Object.assign(Object.assign({}, commonProperties), LeadsOpenSeaVO_OBJ);
    }
    else {
        return commonProperties;
    }
};
export const transServerCustomerModel = (list, type, isWaModel) => {
    const contactMap = {};
    const customerMap = {};
    const customerContactList = [], customerList = [];
    list === null || list === void 0 ? void 0 : list.forEach(item => {
        var _a, _b, _c, _d;
        if ((item === null || item === void 0 ? void 0 : item.company_type) === 'clue' || (item === null || item === void 0 ? void 0 : item.company_type) === 'openSea') {
            const model = transServerCustomer2CustomerModel(item);
            const customerId = model === null || model === void 0 ? void 0 : model.id;
            if (customerId) {
                customerMap[customerId] = model;
                customerList.push(model);
                const currentContactList = [];
                const customerRole = mailPlusCustomerApi.doGetCustomerRoleByModel(item);
                (_a = item.contact_list) === null || _a === void 0 ? void 0 : _a.forEach(contact => {
                    if (contact && contact.email) {
                        const contactData = transServerCustomerContact2ContactModel({
                            item: contact,
                            type: type || item.company_type || 'customer',
                            id: model.id,
                            role: customerRole,
                        });
                        currentContactList.push(contactData);
                        customerContactList.push(contactData);
                    }
                });
                contactMap[customerId] = currentContactList;
            }
        }
        else {
            const hasEmail = !!((_b = item.contact_list) === null || _b === void 0 ? void 0 : _b.some(curContact => curContact === null || curContact === void 0 ? void 0 : curContact.email)) || !!((_c = item.main_contact) === null || _c === void 0 ? void 0 : _c.email);
            if (hasEmail || isWaModel) {
                const model = transServerCustomer2CustomerModel(item);
                const customerId = model === null || model === void 0 ? void 0 : model.id;
                if (customerId) {
                    customerMap[customerId] = model;
                    customerList.push(model);
                    const currentContactList = [];
                    const customerRole = mailPlusCustomerApi.doGetCustomerRoleByModel(item);
                    (_d = item.contact_list) === null || _d === void 0 ? void 0 : _d.forEach(contact => {
                        if (contact) {
                            const contactData = transServerCustomerContact2ContactModel({
                                item: contact,
                                type: type || item.company_type || 'customer',
                                id: model.id,
                                role: customerRole,
                            });
                            currentContactList.push(contactData);
                            customerContactList.push(contactData);
                        }
                    });
                    contactMap[customerId] = currentContactList;
                }
            }
        }
    });
    return {
        customerContactList,
        customerList,
        contactMap,
        customerMap,
    };
};
const parseEmailRole = (emailRole) => {
    const lxType = ['personal', 'enterprise', 'external'];
    const edmType = ['customer', 'clue'];
    if (lxType.includes(emailRole)) {
        return {
            type: emailRole,
            role: undefined,
            isEdm: false,
        };
    }
    else {
        const _emailRole = emailRole.toLocaleLowerCase();
        const res = {
            type: 'external',
            role: undefined,
            isEdm: false,
        };
        edmType.some(item => {
            const list = _emailRole.split(item);
            if (list.length > 1) {
                res.type = item;
                res.role = list[0];
                res.isEdm = true;
                return true;
            }
            return false;
        });
        return res;
    }
};
export const transEmailRoleBase2ContactModel = (item) => {
    const { role, email, companyId, contactId: id, contactName, contactAvatar, customerCreateTime: createTime, relatedCompanyInfo, } = item;
    const { type, isEdm } = parseEmailRole(role);
    const contactPYName = util.toPinyin(contactName);
    const contactLabel = util.getContactLabel(contactPYName);
    const _lastUpdateTime = Date.now();
    const contact = {
        id,
        contactName,
        contactLabel,
        contactPYName,
        contactPYLabelName: '',
        accountName: email,
        displayEmail: email,
        avatar: contactAvatar,
        visibleCode: 0,
        enableIM: false,
        accountType: 2,
        type: type,
        accountId: id,
        _lastUpdateTime,
    };
    const contactInfo = [
        {
            id: '',
            contactId: id,
            contactItemType: 'EMAIL',
            contactItemVal: email,
            isDefault: 1,
            type,
            contactItemRefer: '',
            _lastUpdateTime,
        },
    ];
    let customerOrgModel;
    if (isEdm) {
        customerOrgModel = {
            createTime,
            role,
            companyId,
            relatedCompanyInfo,
        };
    }
    return {
        contact,
        contactInfo,
        isFull: false,
        customerOrgModel,
    };
};
export const checkContactModelChange = (oldVal, newVal) => {
    const _a = oldVal || {}, { reduxUpdateTime: _u } = _a, prev = __rest(_a, ["reduxUpdateTime"]);
    const _b = newVal || {}, { reduxUpdateTime } = _b, current = __rest(_b, ["reduxUpdateTime"]);
    if (prev && current) {
        return !isEqual(prev, current);
    }
    return true;
};
export const jumpToContactPersonalMark = () => {
    navigate('/#contact', {
        state: {
            selectNodeKey: StaticNodeKey.PERSON_MARK_LIST,
        },
    });
};
export const transICustomerLabelModel2LabelModel = (labelList) => {
    if (!Array.isArray(labelList) || !labelList.length) {
        return [];
    }
    const label_list = labelList === null || labelList === void 0 ? void 0 : labelList.map(i => {
        const { id, name, type, color, companyCount, createTime } = i;
        return {
            label_id: id,
            label_name: name,
            label_type: type,
            label_color_id: '',
            label_color: color,
            label_company_count: companyCount,
            label_create_time: +createTime,
        };
    });
    return label_list;
};
export const transICustomerModel2CustomerDetail = (customerModel) => {
    const { originCompanyId, id, area, zone, website, cLevel, cLevelName, number, logo, domain, companyName, shortName, starLevel, sourceName, sourceId, contactList, managerList, labelList, createTime, create_by, create_by_id, fax, intent, main_industry, purchase_amount, recent_follow_at, recent_follow_by, recent_follow_by_id, require_product, scale, update_by, update_by_id, update_time, status, leads_name, social_media, return_managers, return_remark, return_time, company_name_id, country, country_id, remark, address, telephone, latest_contact, label_names, monitorIdFromBigData, favorite, edm_statistic, } = customerModel;
    const label_list = transICustomerLabelModel2LabelModel(labelList);
    const res = {
        monitorIdFromBigData,
        favorite,
        label_names,
        origin_company_id: originCompanyId,
        company_id: id,
        company_name: companyName,
        company_domain: domain,
        company_logo: logo || '',
        company_number: number || '',
        country,
        company_level: cLevel || '',
        company_level_name: cLevelName || '',
        area: area.split('-').filter(Boolean),
        short_name: shortName || '',
        star_level: starLevel || '',
        intent: `${intent}`,
        label_list,
        main_industry: `${main_industry}`,
        purchase_amount: `${purchase_amount}`,
        zone,
        scale: `${scale}`,
        fax: fax || '',
        telephone: telephone || '',
        address: address || '',
        remark: remark || '',
        pictures: [],
        sourceName: sourceName || '',
        source: sourceId || '',
        social_media,
        contact_list: contactList === null || contactList === void 0 ? void 0 : contactList.map(i => {
            const { id, name, email, isMain } = i;
            return {
                contact_id: id,
                contact_name: name,
                main_contact: !!isMain,
                email,
                label_list,
                contact_icon: '',
                telephones: [],
                whats_app: '',
                social_platform: [],
                job: '',
                home_page: '',
                gender: '',
                birthday: '',
                remark: '',
                pictures: [],
                rejected: false,
                valid: true,
            };
        }),
        manager_list: managerList === null || managerList === void 0 ? void 0 : managerList.map(i => {
            const { managerId, managerName, managerOriginName, managerAccount } = i;
            return { name: managerName || '', manager_name: managerOriginName || '', id: managerId || '', manager_email: managerAccount || '' };
        }),
        system_info: {
            create_time: createTime || '',
            create_user: create_by || '',
            create_user_id: create_by_id || '',
            update_time: update_time || '',
            update_user: update_by || '',
            update_user_id: update_by_id || '',
            moment_time: recent_follow_at || '',
            moment_user: recent_follow_by || '',
            moment_user_id: recent_follow_by_id || '',
        },
        require_product_type_label: require_product || '',
        product_require_level_label: '',
        edit_flag: true,
        website: website || '',
        status,
        leads_name,
        return_managers: return_managers === null || return_managers === void 0 ? void 0 : return_managers.map(i => {
            const { id, name, manager_name } = i;
            return { id, name, manager_name };
        }),
        return_time,
        return_remark,
        company_name_id,
        country_id,
        latest_contact,
        edm_statistic,
    };
    return res;
};
export const getCurrentContactId = () => {
    var _a, _b;
    const user = systemApi.getCurrentUser();
    return ((_a = user === null || user === void 0 ? void 0 : user.contact) === null || _a === void 0 ? void 0 : _a.contact.id) || ((_b = user === null || user === void 0 ? void 0 : user.prop) === null || _b === void 0 ? void 0 : _b.contactId);
};
